import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../common/api";

function AddApplicationToCourseModal({
  application,
  courses,
  show,
  setShow,
}: any) {
  const [selectedCourse, setSelectedCourse] = React.useState<any>(null);

  const onHide = () => {
    setShow(false);
  };

  const handleSubmit = async () => {
    if (!selectedCourse) {
      toast.error("Odaberite grupu priprema");
      return;
    }

    let data = {
      user_ids: [application.applicant.user_id],
    };

    try {
      await api.post(`/courses/${selectedCourse}/add-student/`, data);
      toast.success("Učenik uspješno dodan grupi priprema");
      onHide();
    } catch (error) {
      toast.error("Greška prilikom dodavanja učenika grupi priprema");
      console.error(error);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Dodaj učenika grupi priprema</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="exampleForm.SelectCustom">
          <Form.Label>Grupa priprema</Form.Label>
          <Form.Select
            onChange={(e) => setSelectedCourse(e.target.value)}
            value={selectedCourse}
          >
            <option value="">-- Odaberite grupu priprema -- </option>
            {courses.map((course: any) => (
              <option key={course.id} value={course.id}>
                {course.title}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Dodaj
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddApplicationToCourseModal;
